<script lang="ts" module>
  export interface CampaignCardProps extends ActionComponentProps {
    image: string;
    title: string;
    badgeLabel: string;
    description: string;
    buttonLabel?: string;
    discountLabel?: string;
    size?: 'sm' | 'md' | 'lg';
    href: string;
    customProps?: {[x: string]: any}; // For CMS to pass in props for component management
  }

</script>

<script lang="ts">
  import type { ActionComponentProps } from '@agapi/ui/utils';
  import { Badge } from '@agapi/ui/badge';
  import { Button } from '@agapi/ui/button';
  import { Card, CardImage, CardContent, CardHeader, CardFooter } from '@agapi/ui/card';
  import { css } from '@agapi/ui/panda/css';
  import { ShoppingCartSimple } from 'phosphor-svelte';
  import { campaignCardStyles } from './campaign-card.styles';
  import { float } from '@agapi/ui/panda/patterns';
  import CampaignBadge from '../campaign-badge/campaign-badge.svelte';
  import { rewriteUrl } from '../../utils';
  import { page } from '$app/state';

  const {
    use,
    image,
    title,
    badgeLabel,
    description,
    buttonLabel,
    discountLabel,
    size = 'md',
    href,
    customProps
  }: CampaignCardProps = $props();


  const classes = $derived(campaignCardStyles.raw({ size }));

  const imageWidth = size === 'sm' ? 360 : size === 'md' ? 600 : 800;
  const imageAspectRatio = size === 'sm' ? 9/16 : size === 'md' ? 16 / 9 : 16 / 9;
</script>

<Card use={use} {...customProps} css={classes.root} spacing="snug">
  {#if discountLabel}
    <CampaignBadge size="lg" colorVariant="campaign" css={float.raw({zIndex: 9, offset: "49px", pointerEvents: 'none'})}>{discountLabel}</CampaignBadge>
  {/if}
  <a href={rewriteUrl(page, href)} class={css(classes.link)}>
    <CardImage src={image} alt={title} fetchpriority="high" loading="eager" aspectRatio={"auto"} css={classes.image} background={image + '/m/8x0'} fit="contain"/>
      <CardHeader css={classes.header}>
        {#if badgeLabel}
          <Badge>{badgeLabel}</Badge>
        {/if}
        <h2 class={css(classes.heading)}>{title}</h2>
      </CardHeader>
      <CardContent css={classes.content}>
        <span class={css(classes.description)}>{description}</span>
      </CardContent>
      <CardFooter>
        {#if buttonLabel}
          <Button as="a" href={rewriteUrl(page, href)}>{buttonLabel}<ShoppingCartSimple style="bold">
            <title>{m.iconShoppingCartAdd()}</title>
          </ShoppingCartSimple></Button>
        {/if}
      </CardFooter>
  </a>
</Card>
